import { render, staticRenderFns } from "./OrarioWebImportWizard.vue?vue&type=template&id=2523d5dc&scoped=true"
import script from "./OrarioWebImportWizard.vue?vue&type=script&lang=js"
export * from "./OrarioWebImportWizard.vue?vue&type=script&lang=js"
import style0 from "./OrarioWebImportWizard.vue?vue&type=style&index=0&id=2523d5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523d5dc",
  null
  
)

export default component.exports